import { ActionMenuItem, BaseActionEnum, BaseActions } from "../../../components/action-menu/ActionMenuItem";
import { DateColumnTypeEnum, IConfiguration, ILogEntry, ImportTypeEnum, LogEntryTypeEnum } from "../../../services/data-file-import-data-service/Models";
import { VirtualizedListItem } from "../../../components/virtualized-list/VirtualizedList";
import i18n from "../../../services/localization-service/i18n";
import Enumerable from "linq";
import { Box, Stack, Typography } from "@mui/material";
import { getActionMenuItems } from "../../../components/action-menu/BaseActions";


import type { JSX } from "react";


export enum DataFileImportActionEnum {
    //Add = 'add',
    Rename = 'rename',
    Run = 'run',
    Delete = 'delete',
    Edit = 'edit'
}

export type DataFileImportActionItem = {
    action: DataFileImportActionEnum | BaseActions
} & ActionMenuItem;

export type DataFileImportItem = {

} & IConfiguration & VirtualizedListItem;

export type ImportTypeOption = {
    text: string,
    value: ImportTypeEnum
};

export const importTypes: ImportTypeOption[] = [{
    text: i18n.t("dataFileImport.importTypes.all"),
    value: ImportTypeEnum.None
}, {
    text: i18n.t("dataFileImport.importTypes.single"),
    value: ImportTypeEnum.Single
}, {
    text: i18n.t("dataFileImport.importTypes.multiple"),
    value: ImportTypeEnum.Multiple
}];


const actionEnums = [
     BaseActionEnum.CreateNew,
     BaseActionEnum.Refresh,
];

export const actions = getActionMenuItems(actionEnums);

export const actionItems = actions.map(o => {

    if (o.action === BaseActionEnum.CreateNew) {
        o.label = i18n.t("actions.newDataFileImport");
    }

    return o;
});




function _getLogEntryMessage(logEntry: ILogEntry) {

    let message: string = "";
    let columnID: number | undefined = logEntry.columnID !== undefined ? 
                        logEntry.columnID + 1 :
                        undefined;

    switch (logEntry.logEntryType) {
        case LogEntryTypeEnum.AllTagsProcessed:
            break;

        case LogEntryTypeEnum.IdentifierNotMatched:
            message = `Identifier: ${logEntry.identifier} Import Type: ${logEntry.importType} Row Number: ${logEntry.rowNumber} ` +
                `Column Index: ${columnID} Column Name: ${logEntry.columnName}`;

            break;

        case LogEntryTypeEnum.InvalidData:
            message = `Row Number: ${logEntry.rowNumber} Column Index: ${columnID} Column Name: '${logEntry.columnName}' ` +
                `Value: ${logEntry.cellValue}`;

            break;

        case LogEntryTypeEnum.InvalidDateTime:

            if (logEntry.dateColumnType === DateColumnTypeEnum.One) {
                message = `Row Number: ${logEntry.rowNumber} Date Column Index: ${columnID} Date Column Name: '${logEntry.columnName}' ` +
                    `Value: ${logEntry.cellValue}`;
            }
            else {
                message = `Row Number: ${logEntry.rowNumber} Date Column Index: ${columnID} Date Column Name: '${logEntry.columnName}' ` +
                    `Time Column Index: ${logEntry.secondaryColumnID} Time Column Name: ${logEntry.secondaryColumnName} ` +
                    `Value: ${logEntry.cellValue}`;
            }

            break;

        case LogEntryTypeEnum.MissingDateTime:

            if (logEntry.dateColumnType === DateColumnTypeEnum.One) {
                message = `Row Number: ${logEntry.rowNumber} Date Column Index: ${columnID} Date Column Name: '${logEntry.columnName}'`;
            }
            else {
                message = `Row Number: ${logEntry.rowNumber} Date Column Index: ${columnID} Date Column Name: '${logEntry.columnName}' ` +
                    `Time Column Index: ${logEntry.secondaryColumnID} Time Column Name: ${logEntry.secondaryColumnName}`;
            }

            break;

        case LogEntryTypeEnum.MissingTag:
            message = `Row Number: ${logEntry.rowNumber} Column Index: ${columnID} Column Name: '${logEntry.columnName}'`;

            break;

        case LogEntryTypeEnum.NoReadPermissions:
            break;

        case LogEntryTypeEnum.NotActive:
            break;

        case LogEntryTypeEnum.MissingIdentifier:
            message = `Row Number: ${logEntry.rowNumber} Column Index: ${columnID} Column Name: '${logEntry.columnName}'`;

            break;

        case LogEntryTypeEnum.ProcessingError:
            message = `Identifier: ${logEntry.identifier} Row Number: ${logEntry.rowNumber} Error: ${logEntry.message}`;

            break;
    }
    return message;
}


function _getLogEntryTypeName(logEntryType: LogEntryTypeEnum): string {

    let logEntryTypeName: string = "Invalid LogEntryTypeEnum";

    switch (logEntryType) {

        case LogEntryTypeEnum.AllTagsProcessed:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.allTagsProcessed");
            break;
        case LogEntryTypeEnum.IdentifierNotMatched:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.identifierNotMatched");
            break;

        case LogEntryTypeEnum.InvalidData:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.invalidData");
            break;

        case LogEntryTypeEnum.InvalidDateTime:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.invalidDateTime");
            break;

        case LogEntryTypeEnum.MissingDateTime:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.missingDateTime");
            break;

        case LogEntryTypeEnum.MissingTag:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.missingTag");
            break;

        case LogEntryTypeEnum.NoReadPermissions:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.noReadPermissions");
            break;

        case LogEntryTypeEnum.NotActive:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.notActive");
            break;

        case LogEntryTypeEnum.MissingIdentifier:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.missingIdentifier");
            break;

        case LogEntryTypeEnum.ProcessingError:
            logEntryTypeName = i18n.t("dataFileImport.logEntryTypeEnum.processingError");
            break;
    }

    return logEntryTypeName;
}



const DataFileImportListUtils = {

    shapeData: function(data: IConfiguration[],
        filterText: string,
        importType: ImportTypeEnum
        ) : DataFileImportItem[] {

        const dataFileImport = data?.filter(o => o.importType === importType || importType === ImportTypeEnum.None)
        .filter(o => o.name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 || filterText === '');

        return dataFileImport;
    },
    shapeImportLogs: function (logEntries: ILogEntry[]): JSX.Element {

        const groupedEntires = Enumerable.from(logEntries)
                            .groupBy(o => `${o.object?.objectType}:${o.object?.id}`)
                            .toArray()
                            .map(o => {
                                const items = o.toArray();
                                return {
                                    item: items[0],
                                    logItems: items
                                }
                            });
    
        return (
            <Box>
                {
                groupedEntires.map((o, ndx) => 
                    <Stack direction='column' key={ndx} sx={{
                        marginBottom: 1
                    }}>
                        <Typography variant='subtitle2' sx={{
                            marginBottom: 1
                        }}>
                            {_getLogEntryTypeName(o.item.logEntryType)}
                        </Typography>
        
                        <Stack direction='column' sx={{
                            marginLeft: 1
                        }}>
                            <Typography variant="body2">
                                {o.item.object?.displayText ?? ''}
                            </Typography>
                            {
                                o.item.logEntryType !== LogEntryTypeEnum.NoReadPermissions &&
                                o.logItems.map(v => 
        
                                    <Typography variant="body2">
                                        {_getLogEntryMessage(v)}
                                    </Typography>
                                )
                            }
                        </Stack>
        
                    </Stack>
                )
                }
                
            </Box>
        );
    }
    


        


}

export default DataFileImportListUtils;

